import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';
import { NbToastrService } from '@nebular/theme';
import { Publication } from '../../shared/data/publication';
import { plainToClass } from 'class-transformer';
import { ApiService } from '../../shared/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';


@Component({
  template: `
  <div class="col-sm-12">
    <nb-toggle [(ngModel)]="value" name="publier" (click)="publish()">Publier</nb-toggle>
  </div>
  `,
})
export class PublishRenderComponent implements ViewCell, OnInit {

  renderValue: number;

  @Input() value: number;
  @Input() rowData: any;

  pub: Publication;


  constructor( public toastr:NbToastrService, private apiService:ApiService, private router:Router) {
  }

  ngOnInit() {
    // this.renderValue = this.value.toString().toUpperCase();
    this.renderValue = this.value;
    this.pub = plainToClass( Publication, this.rowData as object);
    
  }

  publish() {

    let val = false;
    console.log( this.rowData );
    if( !this.value )
    val = true
    // this.toastr.success('Publié(e)', this.pub.titre);
    else
    val = false
    // this.toastr.success('depublié(e)', this.pub.titre);


    this.apiService.activePublicationProvider(this.pub.id, val).subscribe(data =>{

      if( this.value )
      this.toastr.success('Publié(e)', this.pub.titre);
      else
      this.toastr.success('Dépublié(e)', this.pub.titre);
     
    },(err) =>{

      // this.value = !this.value
    
      this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
      
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
        
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })

  }

}
